import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import AdBanner from '../components/AdBanner';

const galleryImages = [
  { id: 1, url: "https://images.unsplash.com/photo-1560493676-04071c5f467b", alt: "Aerial view of farm", category: "farm" },
  { id: 2, url: "https://images.unsplash.com/photo-1495107334309-fcf20504a5ab", alt: "Farm landscape", category: "landscape" },
  { id: 3, url: "https://images.unsplash.com/photo-1500595046743-cd271d694d30", alt: "Cattle grazing", category: "livestock" },
  { id: 4, url: "https://images.unsplash.com/photo-1655912108021-5a81aa63cc3d", alt: "Cassava crops", category: "crops" },
  { id: 5, url: "https://images.unsplash.com/photo-1726177973715-9d17703e8d68", alt: "Mushroom cultivation", category: "mushroom" },
  { id: 6, url: "https://images.unsplash.com/photo-1574943320219-553eb213f72d", alt: "Traditional farming", category: "farming" }
];

const Gallery = () => {
  const [filter, setFilter] = useState('all');

  const filteredImages = filter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === filter);

  const categories = [
    { value: 'all', label: 'All' },
    { value: 'farm', label: 'Farm Views' },
    { value: 'livestock', label: 'Livestock' },
    { value: 'crops', label: 'Crops' },
    { value: 'mushroom', label: 'Mushroom' },
    { value: 'farming', label: 'Farming Activities' }
  ];

  return (
    <div className="gallery-page">
      {/* Page Header */}
      <section className="page-header py-20 px-4 bg-gradient-to-b from-green-50 to-white">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Our Gallery
          </h1>
          <p className="text-xl text-gray-600">
            A visual journey through Daye Farm Ltd.
          </p>
        </div>
      </section>

      {/* Filter Buttons */}
      <section className="filter-section py-12 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <Button
                key={category.value}
                onClick={() => setFilter(category.value)}
                variant={filter === category.value ? 'default' : 'outline'}
                className="transition-all duration-300"
              >
                {category.label}
              </Button>
            ))}
          </div>
        </div>
      </section>

      {/* Advertisement Banner */}
      <section className="ad-section py-8 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <AdBanner placement="gallery" />
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="gallery-grid-section py-12 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredImages.map((image) => (
              <div 
                key={image.id} 
                className="gallery-item h-80 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
              >
                <img 
                  src={image.url} 
                  alt={image.alt} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                  <p className="text-white font-semibold text-lg">{image.alt}</p>
                </div>
              </div>
            ))}
          </div>

          {filteredImages.length === 0 && (
            <div className="text-center py-20">
              <p className="text-xl text-gray-600">No images found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Additional Farm Views */}
      <section className="additional-views py-20 px-4 bg-gradient-to-b from-white to-green-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">
            More From Our Farm
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="h-96 rounded-2xl overflow-hidden shadow-xl group">
              <img 
                src="https://images.unsplash.com/photo-1700743625236-23f6121862e3" 
                alt="Farmers at work" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="h-96 rounded-2xl overflow-hidden shadow-xl group">
              <img 
                src="https://images.unsplash.com/photo-1744726010540-bf318d4a691f" 
                alt="Organized crop rows" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;